import {ChangeDetectionStrategy, Component, HostListener} from '@angular/core';
import {RouterLink} from "@angular/router";
import {TranslatePipe} from "@ngx-translate/core";
import {DatePipe} from "@angular/common";
import {LanguageService} from '../../services/language.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    imports: [
        RouterLink,
        TranslatePipe,
        DatePipe
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
    public showScroll: boolean | undefined;
    public showScrollHeight = 500;
    public hideScrollHeight = 10;
    today: number = Date.now();

    constructor(public language: LanguageService) {
    }


    @HostListener('window:scroll', [])
    onWindowScroll() {
        if ((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) > this.showScrollHeight) {
            this.showScroll = true;
            // tslint:disable-next-line: max-line-length
        } else if (this.showScroll && (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) < this.hideScrollHeight) {
            this.showScroll = false;
        }
    }
}
